import { useState } from "react"

import Style from "./style"
import close from "./asset/close.svg"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"

const AlertModal = ({ title, closeEvent, list, buttonLabel, clickEvent }) => {

    const [agreeCheckList, setAgreeCheckList] = useState(list.map(() => false))
    const [isException, setIsException] = useState(false)

    const checkEvent = (index) => {
        const tmpList = [...agreeCheckList]
        tmpList[index] = !tmpList[index]
        setAgreeCheckList(tmpList)
    }

    const submitEvent = () => {
        if (agreeCheckList.includes(false)) {
            setIsException(true)
        } else {
            clickEvent()
        }
    }

    return (
        <DefaultModal>
            <Style.Wrapper>

                <Style.TitleDiv>
                    <h2>{title}</h2>
                    <button onClick={closeEvent}><img src={close} /></button>
                </Style.TitleDiv>

                <Style.AgreeList>
                    {list.map((elem, index) =>
                        <Style.AgreeElement $size={list.length}>
                            <Style.AgreeCheckButton onClick={() => checkEvent(index)}>
                                <img src={agreeCheckList[index] ? checked : check} />
                                <h2>{elem?.title}</h2>
                            </Style.AgreeCheckButton>
                            {isException && !agreeCheckList[index] &&
                                <Style.Exception>필수 항목 동의가 필요합니다.</Style.Exception>
                            }
                            <Style.AgreeContent>{elem.content}</Style.AgreeContent>
                        </Style.AgreeElement>
                    )}
                </Style.AgreeList>

                <DefaultButton clickEvent={submitEvent}>{buttonLabel}</DefaultButton>

            </Style.Wrapper>
        </DefaultModal >
    )
}

export default AlertModal